import { minimumWidth, pxToRem, styled } from '@feast-it/ui/light';

export const TrustpilotReviewsWrapper = styled.div<{ isLoading: boolean }>`
  ${({ theme, isLoading }) => `
    padding:  ${pxToRem(13)} ${theme.spacing[2]} ${theme.spacing[2]};
    border-radius: ${pxToRem(10)};
    opacity: ${isLoading ? 0 : 1};
    transition: opacity ease-in 0.5s;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 91%;
    min-width: ${pxToRem(120)};
    background: ${theme.colors.white};
    border: solid ${pxToRem(1)} ${theme.colors.mediumGrey};
     iframe {
        height: ${pxToRem(64)} !important;
      }

    ${minimumWidth(theme.breakpoints.small)} {
      padding-top: ${theme.spacing[2]};
      width: 39%;
      max-width: ${pxToRem(180)};

    }

    ${minimumWidth(theme.breakpoints.large)} {
      padding-top: ${pxToRem(13)};
      width: 73%;
      max-width: unset;
    }
  `};
`;
